import GigList from "../components/Gigs.js";
import Contact from "./Contact.js";

import "../styles/Home.css";

import homephoto from "../gallery/12.jpg";
import bottomphoto from "../gallery/3.jpg";

export default function Home() {
  return (
    <div id="main">
      <div className="top">
        <img src={homephoto} className="homephoto"></img>
        <div>
          <p className="description-title">Killtaker</p>
          <p className="description">
            Five-piece based in East London. Post-hardcore inspired. Book us.
          </p>
        </div>
      </div>

      <div className="bottom">
        <GigList></GigList>

        <div>
          <div id="home-gallery">
            <span>GALLERY</span>
            <a href="/gallery">See More &rarr;</a>
          </div>
          <img src={bottomphoto} className="bottomphoto"></img>
        </div>
      </div>

      <Contact></Contact>
    </div>
  );
}
